import React, { useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { permissionsAccess } from '../../helpers/common';

import './aside.scss';

import CloseIcon from '../../assets/icons/close.svg';
import ClientsIcon from '../../assets/icons/clients.svg';
import ClientsSmallIcon from '../../assets/icons/clients-small.svg';
import ReportsIcon from '../../assets/icons/reports.svg';
import ExchangeIcon from '../../assets/icons/exchange.svg';
import DelayIcon from '../../assets/icons/delay.svg';
import AddClientIcon from '../../assets/icons/add-client.svg';
import QuickCalculationIcon from '../../assets/icons/quick-calculation.svg';
import HandbookIcon from '../../assets/icons/handbook.svg';
import EnvelopIcon from '../../assets/icons/envelope.svg';
import CarIcon from '../../assets/icons/car.svg';
import {useSelector} from "react-redux";

const entityLi = {
  mainItems: [
    { to: '/search-results/clients', icon: <ClientsIcon />, text: 'Клиенты' },
    { to: '/cash-desk/cash', icon: <ReportsIcon />, text: 'Кассы и отчёты' },
    { to: '/overdue', icon: <DelayIcon />, text: 'Просрочки' },
    { to: '/exchange-kb', icon: <ExchangeIcon />, text: 'Обмен с КБ' },
    { to: '/notification', icon: <EnvelopIcon />, text: 'Уведомления и СМС' },
    { to: '/auto', icon: <CarIcon />, text: 'Автоломбард' }
  ],
  subItems: [
    { to: '/client', icon: <AddClientIcon />, text: 'Добавить клиента' },
    { to: '/quick-calculation', icon: <QuickCalculationIcon />, text: 'Быстрый расчёт' },
  ],
  bottomItems: [
    { to: '/handbooks/departments', icon: <HandbookIcon />, text: 'Справочники' },
    { to: '/users', icon: <ClientsSmallIcon />, text: 'Пользователи' },
  ],
};

const Aside = ({ isMainMenuShown, onChangeMenuState }) => {
  const showHandbookLink = permissionsAccess("handbooks.global")
  const {accessFeatures} = useSelector(({user}) => user);

  const wrapperRef = useRef();
  const {
    location: { pathname },
  } = useHistory();

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const handleClickOutside = (event) => {
    if (wrapperRef && !wrapperRef.current.contains(event.target)) {
      if (isMainMenuShown) {
        onChangeMenuState();
      }
    }
  };

  const createLi = (data) => {
    return data.map((i) => {
      if (i.to === '/client') {
        return permissionsAccess("action.client.create") ? (
            <CustomLi key={i.text} pathname={pathname} entity={i}/>
        ) : null;
      }
      if (i.to === '/quick-calculation') {
        return permissionsAccess("action.branch.calculate") ? <CustomLi key={i.text} pathname={pathname} entity={i}/> : null;
      }
      if (i.to === '/users') {
        return permissionsAccess("action.employee.list") ? <CustomLi key={i.text} pathname={pathname} entity={i}/> : null;
      }

      if (i.to === '/handbooks/departments') {
        return showHandbookLink ? <CustomLi key={i.text} pathname={pathname} entity={i} /> : null;
      }

      if (i.to === '/exchange-kb') {
        return permissionsAccess("action.integration.kb.list") ? <CustomLi key={i.text} pathname={pathname} entity={i} /> : null;
      }

      if (i.to === '/notification') {
        return permissionsAccess("action.sms.list") ? <CustomLi key={i.text} pathname={pathname} entity={i} /> : null;
      }
      if (i.to === '/auto') {
        return accessFeatures['cash_box.auto.enable'] ? <CustomLi key={i.text} pathname={pathname} entity={i} /> : null;
      }

      return <CustomLi key={i.text} pathname={pathname} entity={i} />;
    });
  };

  return (
    <aside className={isMainMenuShown ? 'open' : ''}>
      <div ref={wrapperRef} className="aside-container">
        <button className="aside-closetrigger" onClick={onChangeMenuState}>
          <CloseIcon />
        </button>
        <p className="aside-label">Меню</p>
        <ul className="aside-menu">{createLi(entityLi.mainItems)}</ul>

        <ul className="aside-menu subitems">{createLi(entityLi.subItems)}</ul>

        <ul className="aside-menu subitems bottomitems">{createLi(entityLi.bottomItems)}</ul>
      </div>
    </aside>
  );
};

export default Aside;

function CustomLi({ pathname, entity }) {
  return (
    <li className={pathname === entity.to ? 'active' : ''}>
      <Link to={entity.to}>
        <span className="icon">{entity.icon}</span>
        <span>{entity.text}</span>
      </Link>
    </li>
  );
}
